module.exports = __webpack_public_path__ + "static/media/line-half.f6446fd2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nxbus/line-half.svg
// module id = 772
// module chunks = 0